// freshnessDisplay.js
// Utility for displaying "Fresh for N days" values in the UI.
// Internally stored maxStorageTime may range 2-7; UI caps at 5 for consistency.

import { LONG_SHELF_LIFE_THRESHOLD } from './storageClassifier';

const FRESHNESS_DISPLAY_CAP = 5;

/**
 * Caps a freshness value for UI display. Handles numbers, numeric strings,
 * and strings like "5 days" / "3d". Returns a number capped at 5, or the
 * original value if it cannot be parsed.
 *
 * @param {string|number} value
 * @returns {number|string}
 */
export const capDisplayFreshness = (value) => {
  if (value == null) return value;
  const num = typeof value === 'number' ? value : parseInt(String(value), 10);
  if (!Number.isFinite(num)) return value;
  return Math.min(num, FRESHNESS_DISPLAY_CAP);
};

/**
 * Format a storage shelf-life value for the grocery "Conservación" badge.
 * Long-lasting items (canned/dried/frozen staples) show a "long-lasting" label
 * instead of a large raw number; perishables show "N días".
 *
 * @param {Function} t - i18next translation function.
 * @param {string|number} days - shelf-life in days.
 * @returns {string} localized badge text ('' when days is not a positive number).
 */
export const formatShelfLife = (t, days) => {
  const num = typeof days === 'number' ? days : parseInt(String(days), 10);
  if (!Number.isFinite(num) || num <= 0) return '';
  if (num > LONG_SHELF_LIFE_THRESHOLD) return t('grocery.storage.longLasting');
  return `${num} ${t('grocery.storage.days')}`;
};

